import React, { useState } from 'react';
import { authHelpers } from '../global/supabase';
import { BRANDING } from '../config';
import '../global/styles.css';

// Logos loaded dynamically from config
import NTlogo from '../assets/images/NTlogo.jpeg';
const ClientLogo = require(`../assets/images/${BRANDING.logoFilename}`);

function Welcome({ onComplete }) {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      title: "Welcome",
      subtitle: `${BRANDING.appName} - ${BRANDING.appTagline}`,
      showLogos: true
    },
    {
      title: "Let's Get Started",
      subtitle: "Sign in to your account or create a new one to begin tracking your controlled substance inventory.",
      showLogos: false
    }
  ];

  const nextSlide = () => {
    if (currentSlide < slides.length - 1) {
      setCurrentSlide(currentSlide + 1);
    } else {
      // Mark onboarding as complete and proceed to login
      authHelpers.markOnboardingComplete();
      onComplete();
    }
  };

  return (
    <div className="container">
      <div className="content">
        {slides[currentSlide].showLogos && (
          <div className="logo-bg">
            <img src={NTlogo} alt="NarcoticTrack" className="logo-nt" />
          </div>
        )}
        
        <div className="card card-center">
          {slides[currentSlide].showLogos && (
            <div className="logo-container">
              <img src={ClientLogo} alt={BRANDING.companyFullName} className="logo-location" />
            </div>
          )}
          
          <h1 className="title">{slides[currentSlide].title}</h1>
          <p className="subtitle">{slides[currentSlide].subtitle}</p>
          
          <button onClick={nextSlide} className="btn btn-primary btn-rounded">
            {currentSlide < slides.length - 1 ? 'Continue' : 'Log In'}
          </button>
        </div>
      </div>
      
      <footer className="footer">
        <p className="text-small">{BRANDING.appName} © {BRANDING.copyrightYear} {BRANDING.copyright}</p>
      </footer>
    </div>
  );
}

export default Welcome;